import { getAllSubcategories } from '$utils/api/subcategories.util';
import type { ICategory } from 'garden-common';
import { writable } from 'svelte/store';

export const fetchedCategoryStrings = writable<{ _id: string; data: string }[]>([]);
export const fetchedSubcategories = writable();
export const fetchedCategories = writable<ICategory[]>();

export async function refreshCategoriesAndSubcategories() {
  const subcategories = await getAllSubcategories(50);

  fetchedSubcategories.set(subcategories);

  fetchedCategoryStrings.set(
    subcategories.map(i => {
      return { _id: i._id, data: `${i.name}/${i.categoryName}` };
    })
  );
}
